import styled from 'styled-components'

import { LegendItem } from './../barChartCard.styles'

export const BenchmarkLegendItemWrapper = styled(LegendItem)`
    gap: 4px;
`

export { LegendItemLabel } from './../barChartCard.styles'
